import{s as styleInject}from"./style-inject.es-64b5c21f.js";var styles={giphy_player:"_1JieR"};styleInject("._1JieR{display:block;width:100%}");export{styles as s};
//# sourceMappingURL=giphy-viewer-89f8df8e.js.map
